// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import Framework7 from 'framework7/dist/framework7.esm.bundle'
import Framework7Vue from 'framework7-vue/dist/framework7-vue.esm.bundle'
import Routes from './routes'

// Import F7 Styles
import 'framework7/dist/css/framework7.css'
import 'framework7-icons/css/framework7-icons.css'

Vue.use(Framework7Vue, Framework7)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  framework7: {
    routes: Routes
  },
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js